import React from 'react';
import MediaQuery from 'react-responsive';
import ContentLoader from 'react-content-loader';
import PanelContainer from 'components/PanelContainer';

const ListSearchMinimalContentLoader = props => (
  <>
    <MediaQuery query="(min-width: 768px)">
      <PanelContainer
        styles={{
          height: 'auto',
          maxHeight: '185px',
        }}
      >
        <ContentLoader
          height={185}
          width={825}
          speed={2}
          primaryColor="#f3f3f3"
          secondaryColor="#ecebeb"
          {...props}
        >
          <rect x="0" y="87" rx="0" ry="0" width="412" height="48" />
          <rect x="505" y="97" rx="0" ry="0" width="150" height="25" />
          <rect x="671" y="96" rx="0" ry="0" width="150" height="25" />
          <rect x="0" y="22" rx="0" ry="0" width="380" height="34" />
          <rect x="573" y="22" rx="0" ry="0" width="248" height="40" />
        </ContentLoader>
      </PanelContainer>
    </MediaQuery>

    <MediaQuery query="(max-width: 767px)">
      <PanelContainer
        styles={{
          height: 'auto',
          maxHeight: '320px',
        }}
      >
        <ContentLoader
          height={200}
          width={320}
          speed={2}
          primaryColor="#f3f3f3"
          secondaryColor="#ecebeb"
          style={{
            maxHeight: '220px',
          }}
          {...props}
        >
          <rect x="17" y="30" rx="0" ry="0" width="285" height="48" />
          <rect x="87" y="99" rx="0" ry="0" width="135" height="20" />
          <rect x="17" y="141" rx="0" ry="0" width="90" height="25" />
          <rect x="114" y="141" rx="0" ry="0" width="90" height="25" />
          <rect x="212" y="141" rx="0" ry="0" width="90" height="25" />
        </ContentLoader>
      </PanelContainer>
    </MediaQuery>
  </>
);

export default ListSearchMinimalContentLoader;
